import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'underscore';
// import twitter from 'twitter-text';
import { trim } from 'underscore.string';
import moment from 'moment-timezone';

Vue.use(Vuex);

function duplicateArr(arr) {
    return arr.map( a => Object.assign({}, a) );
}

function isGif(attachment) {
    if (attachment.source !== undefined && attachment.source && attachment.source.split('.').pop().toLowerCase().substring(0,3) == 'gif') {
        return true;
    }

    if (attachment.thumbnail !== undefined && attachment.thumbnail.startsWith('data:image/gif')) {
        return true;
    }

    return false;
}

var store = new Vuex.Store({
    $app: null,
    state: {
        mode: null,
        done: false,
        message: '',
        // twitterMessage: '',
        // separateTweet: false,
        connections: [],
        submitted: false,
        processing: false,
        createdAt: null,
        start: null,
        schedule: false,
        scheduledFor: null,
        scheduleIsPast: false,
        attachments: [],
        recommendedContent: [],
        recommendedDay: null,
        recommendedItem: null,
        uuid: null,
        hash: null,
        suggested: {
            copy_tip: null,
            facebook: null,
            // twitter: null,
        },
        deleted: false,
        dropzoneInit: false,
        stickyConnections: [],
        inLibrary: false,
        repost: false,
        hasInvalidConnections: false,
        reconnected: false,
        timezoneMismatch: false,
        productInfo: null,
        pinterest_token_invalid: false,
    },
    getters: {
        done(state) {
            return state.done;
        },
        mode: state => {
            return state.mode;
        },
        recommendedContent: state => {
            return state.recommendedContent;
        },
        recommendedDay: state => {
            return state.recommendedDay;
        },
        currentRecommendedContent(state, getters) {
            return state.recommendedContent[state.recommendedDay];
        },
        recommendedContentDate(state, getters) {
            return getters.currentRecommendedContent.date;
        },
        selectedConnections: state => {
            return state.connections.filter(connection => connection.selected);
        },
        deselectedConnections: state => {
            return state.connections.filter(connection => (connection.selected === false));
        },
        failedConnections: state => {
            return state.connections.filter(connection => connection.selected && connection.status == 'failed');
        },
        cancelledConnections: state => {
            return state.connections.filter(connection => connection.selected && connection.status == 'cancelled');
        },
        /* hasTwitter(state) {
            return state.connections.filter(connection => connection.type === 'App\\TwitterAccount').length > 0;
        }, */
        hasPinterest(state) {
            return state.connections.filter(connection => connection.type === 'App\\PinterestAccount').length > 0;
        },
        hasFacebook(state) {
            return state.connections.filter(connection => connection.type === 'App\\FacebookAccount').length > 0;
        },
        hasInstagram(state) {
            return state.connections.filter(connection => connection.type === 'App\\InstagramPage').length > 0;
        },
        hasFacebookPageOrGroup(state) {
            return state.connections.filter(connection => connection.type === 'App\\FacebookPage').length > 0 ||
                state.connections.filter(connection => connection.type === 'App\\FacebookGroup').length > 0;
        },
        hasOtherNetwork(state) {
            return state.connections.filter(connection => connection.type === 'App\\OtherNetworkPage').length > 0;
        },
        /* hasTwitterSelected(state, getters) {
            return getters.selectedConnections.filter(connection => connection.type === 'App\\TwitterAccount').length > 0;
        }, */
        hasFacebookProfileSelected(state, getters) {
            return getters.selectedConnections.filter(connection => connection.type === 'App\\FacebookAccount').length > 0;
        },
        hasInstagramSelected(state, getters) {
            return getters.selectedConnections.filter(connection => connection.type === 'App\\InstagramPage').length > 0;
        },
        hasOtherNetworkSelected(state, getters) {
            return getters.selectedConnections.filter(connection => connection.type === 'App\\OtherNetworkPage').length > 0;
        },
        selectedOtherNetworkPages(state, getters) {
            return getters.selectedConnections.filter(connection => connection.type === 'App\\OtherNetworkPage');
        },
        selectedNonOtherConnections: state => {
            return state.connections.filter(connection => connection.selected && connection.type !== 'App\\OtherNetworkPage');
        },
        valid: (state, getters) => {
            return getters.errors.length === 0;
        },
        /* tweetLongerThan280Chars(state, getters) {
            return getters.tweetCharCount > 280;
        },
        tweetCharCount(state, getters) {
            return twitter.parseTweet(getters.tweetWithUrls).weightedLength;
        },
        tweetWithUrls(state, getters) {
            var message = state.twitterMessage;

            if( getters.attachmentsDummyUrls !== null) {
                message += getters.attachmentsDummyUrls;
            }

            return message;
        }, */
        attachmentsDummyUrls(state, getters) {
            if(state.attachments.length > 0) {
                var attachments = state.attachments.filter(function (attachment) {
                    return attachment.contentType === 'App\\Content\\Video' || attachment.contentType === 'App\\Content\\URL';
                });

                // If there is no URL or Video attachment return null
                if( attachments.length === 0 ) {
                    return null;
                }

                return ' ' + attachments.map(function () {
                    return 'https://example.com/';
                }).join(' ');
            }
            return null;
        },
        errors: (state, getters) => {
            var errors = [];

            if(getters.selectedConnections.length === 0) {
                errors.push(store._vm.$i18n.post_anything.errors.select_at_least_one);
            }

            var settingFBCover = (getters.selectedConnections.length == 1 && getters.selectedConnections[0].type === 'App\\FacebookPage' && state.attachments.length === 1 && state.attachments[0].contentType == 'App\\Content\\FBCover' && state.scheduledFor !== null);

            // Message is always required
            if( ! state.message && !settingFBCover){
                errors.push(store._vm.$i18n.post_anything.errors.message_field);
            }

            // if Twitter is selected Twitter message is required
            /* var twConnection = _.find(state.connections, connection => connection.type === 'App\\TwitterAccount');
            if(twConnection !== undefined && twConnection.selected) {
                if( ! state.twitterMessage ){
                    errors.push(store._vm.$i18n.post_anything.errors.twitter_message_required);
                }

                if( getters.tweetLongerThan280Chars ) {
                    errors.push(store._vm.$i18n.post_anything.errors.tweet_too_long);
                }
            } */

            var pinterestConnection = _.find(state.connections, connection => connection.type === 'App\\PinterestAccount');
            if(pinterestConnection !== undefined && pinterestConnection.selected){
                // Make sure there is at least one attachment
                if(state.attachments.length === 0){
                    errors.push(store._vm.$i18n.post_anything.errors.attachment_required_pinterest);
                }

                // Block Pinterest video
                if(! window.FEATURE_FLAG_PINTEREST_VIDEO_ENABLED) {
                    if (state.attachments[0] !== undefined && state.attachments[0].source !== null) {
                        let matches = state.attachments[0].source.match('(http[s]?://)?([^/*]+/)?(.*)');
                        let path = matches[3].split('?').shift();
                        let ext = path.split('.').pop().toLowerCase().substring(0,3);

                        if(ext == 'mp4') {
                            errors.push(store._vm.$i18n.post_anything.errors.video_no_pinterest);
                            store.commit('toggleConnection', pinterestConnection);
                        }
                    }
                }

                // Make sure a board was selected
                // If selected board is not found in possible boards
                var selectedBoard = _.find(pinterestConnection.boards.data, board => {
                    return board.id === pinterestConnection.boards.selected;
                });

                if(selectedBoard === undefined) {
                    errors.push(store._vm.$i18n.post_anything.errors.select_pinterest_board);
                }
            }

            var instagramConnection = _.find(state.connections, connection => connection.type === 'App\\InstagramPage');
            if(instagramConnection !== undefined && instagramConnection.selected) {
                if(state.attachments.length === 0) {
                    errors.push('Instagram posts require at least one piece of content.');
                } else {
                    state.attachments.forEach((attachment) => {
                        // We're not allowing URL content to be published to Instagram, so throw an error if attached
                        if(attachment.contentType === 'App\\Content\\URL') {
                            errors.push(store._vm.$i18n.post_anything.errors.instagram_url_content_denied);
                        }

                        // Block GIFs from being published to Instagram for now, until we have better handling for them
                        if(isGif(attachment)) {
                            errors.push(store._vm.$i18n.post_anything.errors.instagram_gif_denied);
                        }
                    });
                }

                // Validate count of hashtags and @ mentions in message
                var hashtags = state.message.match(/#[a-zA-Z0-9]+/gi);
                var mentions = state.message.match(/@[a-zA-Z0-9]+/gi);

                // Instagram limits to 30 hashtags
                if (hashtags !== null && hashtags.length > 30) {
                    errors.push(store._vm.$i18n.post_anything.errors.instagram_too_many_hashtags.replace('{0}', hashtags.length));
                }

                // Instagram limits to 20 @ tags/mentions
                if (mentions !== null && mentions.length > 20) {
                    errors.push(store._vm.$i18n.post_anything.errors.instagram_too_many_mentions.replace('{0}', mentions.length));
                }
            }

            let tiktokConnection = _.find(state.connections, connection => connection.type === 'App\\OtherNetworkPage' && connection.name === 'TikTok');
            if(tiktokConnection !== undefined && tiktokConnection.selected) {
                // We're only allowing Video content to be published to TikTok, so throw an error if something else attached
                if(!state.attachments || (state.attachments && (state.attachments.length == 0 || state.attachments[0].contentType !== 'App\\Content\\Video'))) {
                    errors.push(store._vm.$i18n.post_anything.errors.tiktok_only_video_content);
                }
            }

            let snapchatConnection = _.find(state.connections, connection => connection.type === 'App\\OtherNetworkPage' && connection.name === 'Snapchat');
            if(snapchatConnection !== undefined && snapchatConnection.selected) {
                // We're not allowing text-only content to be published to Snapchat, so throw an error if something else attached
                if(!state.attachments || (state.attachments && state.attachments.length == 0)) {
                    errors.push(store._vm.$i18n.post_anything.errors.no_text_only);
                }
            }

            if (getters.hasOtherNetworkSelected && state.message !== null && state.message.length > 1024) {
                errors.push(store._vm.$i18n.post_anything.errors.message_too_long);
            }

            // Check for short URLs
            let shorteners = window.SHORTENERS;

            let regex1 = RegExp('https?://([^/?#]+)(?:[/?#]|$)','gi');

            let match;

            while ((match = regex1.exec(state.message)) !== null) {
                if(shorteners.indexOf(match[1]) >-1) {
                    errors.push(store._vm.$i18n.validation.no_shortener.replace(':attribute', 'message'));
                    break;
                }
            }


            return errors;
        },
        submitted: (state) => {
            return state.submitted;
        },
        allPosted: (state, getters) => {
            return getters.selectedConnections.filter(conn => { return conn.status === 'pending'; }).length === 0;
        },
        somePostsFailed: (state, getters) => {
            return getters.selectedConnections.filter(conn => { return conn.status === 'failed'; }).length > 0;
        },
        facebookAccount: (state, getters) => {
            return state.connections.filter(connection => connection.type == "App\\FacebookAccount")[0];
        },
        facebookPages: (state, getters) => {
            return state.connections.filter(connection => connection.type == "App\\FacebookPage");
        },
        facebookGroups: (state, getters) => {
            return state.connections.filter(connection => connection.type == "App\\FacebookGroup");
        },
        instagramPages: (state, getters) => {
            return state.connections.filter(connection => connection.type == "App\\InstagramPage");
        },
        /* twitterAccount: (state, getters) => {
            return state.connections.filter(connection => connection.type == "App\\TwitterAccount")[0];
        }, */
        pinterestAccount: (state, getters) => {
            return state.connections.filter(connection => connection.type == "App\\PinterestAccount")[0];
        },
        pinterestBoards: (state, getters) => {
            var pinterestAccount = getters.pinterestAccount;
            return pinterestAccount.boards || null;
        },
        otherNetworkPages: (state, getters) => {
            return state.connections.filter(connection => connection.type == "App\\OtherNetworkPage");
        },
        getNextDayIndex(state, getters) {
            var content = state.recommendedContent[state.recommendedDay + 1];

            if(content === undefined) {
                return null;
            }

            return state.recommendedDay + 1;
        },
        hasNextDay(state, getters) {
            return getters.getNextDayIndex !== null;
        },
        prospectCenterConnections: (state, getters) => {
            return state.connections.filter(connection => connection.type !== "App\\PinterestAccount" && connection.type !== "App\\FacebookAccount" && connection.type !== "App\\FacebookGroup");
        },
        uploadsPending: (state, getters) => {
          for(var i = 0; i < state.attachments.length; i++) {
            if(state.attachments[i].progress !== undefined && state.attachments[i].progress !== 100) {
                return true;
            }
          }
          return false;
        },
        scheduledFor: (state) => {
            return state.scheduledFor;
        },
        dropzoneInitialized: (state, getters) => {
            return state.dropzoneInit;
        },
        hasGif (state) {
            return state.attachments.filter(function(attachment) {
                return isGif(attachment);
            }).length > 0;
        },
        isInLibrary(state) {
            return state.inLibrary;
        },
        productInfo: (state) => {
            return state.productInfo;
        },
    },
    mutations: {
        setMode(state, mode) {
            state.mode = mode;
        },

        setDone(state, done) {
            state.done = done;
        },

        setMessage(state, msg) {
            state.message = msg;
        },

        /* setTwitterMessage(state, msg) {
            state.twitterMessage = msg;
        }, */

        /* toggleSeparateTweet(state) {
            state.separateTweet = !state.separateTweet;
        },

        setSeparateTweet(state, st) {
            state.separateTweet = st;
        }, */

        setUuid(state, uuid) {
            state.uuid = uuid;
        },

        setHash(state, hash)  {
            state.hash = hash;
        },

        setRecommendedContent(state, content) {
            state.recommendedContent = content;
        },

        setNextRecommendedContent(state) {
            store.commit('setRecommendedDay', store.getters.getNextDayIndex);
        },

        setRecommendedContentDay(state, payload) {
            var recommendedContent = state.recommendedContent;
            recommendedContent[payload.day].content = payload.content;

            var connection = state.connections.find(connection => {
                return connection.id == payload.post.connection_id && connection.type == payload.post.connection_type;
            });
            var recPosts = recommendedContent[payload.day].posts.data;

            var post = recPosts.find(post => recPosts.connection_type == payload.post.connection_type && recPosts.connection_id == payload.post.connection_id);

            if (post === undefined) {
                recommendedContent[payload.day].posts.data.push(payload.post);
            } else {
                recPosts.map((recPost, index) => {
                    if (recPost.connection_type == post.connection_type && recPost.connection_id == post.connection_id) {
                        recommendedContent[payload.day].posts.data[index] = payload.post;
                    }
                });
            }

            store.commit('setRecommendedContent', recommendedContent);
        },

        setRecommendedDay(state, day) {
            store.commit('clear', day);

            state.recommendedDay = day;

            if (state.recommendedContent[day].content === undefined) {
                return;
            }

            let thumb = state.recommendedContent[day].content.data.thumbnail;

            if (thumb.indexOf('imgix') > -1) {
                thumb += "?fit=crop&w=510&h=510";
            }

            state.recommendedItem = {
                source: state.recommendedContent[day].content.data.source,
                url: state.recommendedContent[day].content.data.source_url,
                thumbnail: thumb,
                progress: 100,
                uploadStatus: 'uploaded',
                contentId: state.recommendedContent[day].content.data.id,
                content: state.recommendedContent[day].content,
                contentType: state.recommendedContent[day].content.data.media_type,
                fromLibrary: true,
            };

            if (state.recommendedContent[day].posts.data[0] === undefined) {
                store.commit('setMessage', '');
                // store.commit('setTwitterMessage', '');
                // store.commit('setSeparateTweet', false);
                store.commit('setAttachments', [state.recommendedItem]);
                state.uuid = null;
                state.hash = null;
            } else {
                var post = state.recommendedContent[day].posts.data[0];

                let message = '';
                // let twitterMessage = '';

                state.recommendedContent[day].posts.data.forEach((p) => {
                    /* if (p.connection_type == 'App\\TwitterAccount') {
                        twitterMessage = p.message;
                    } else {
                        message = p.message;
                        if (twitterMessage == '') {
                            twitterMessage = p.message;
                        }
                    } */
                    message = p.message;
                });

                store.commit('setMessage', message);
                // store.commit('setTwitterMessage', twitterMessage);
                /* if (message != twitterMessage) {
                    store.commit('setSeparateTweet', true);
                } else {
                    store.commit('setSeparateTweet', false);
                } */
                store.commit('setAttachments', [state.recommendedItem]); // TODO: This needs a better solution
                store.commit('setScheduledFor', post.scheduled_at);
                state.recommendedContent[day].posts.data.map((post) => {
                    var connection = state.connections.find(connection => {
                        return connection.id == post.connection_id && connection.type === post.connection_type;
                    });

                    // Only commit/display if the connection is not null
                    // Case: The connection was deleted at a later time by the user
                    if (connection === null || connection === undefined) {
                        return false;
                    }

                    store.commit('toggleConnection', connection);
                    store.commit('setPostId', { connection: connection, postId: post.id });
                    store.commit('setExternalIds', { connection: connection, externalIds: post.external_ids });
                });
                store.commit('setUuid', post.uuid);
                store.commit('setCreatedAt', post.created_at);
            }

            store.commit('setSuggestedCopies', {
                copy_tip: state.recommendedContent[day].content.data.copy_tip || null,
                facebook: state.recommendedContent[day].content.data.suggested_copy || null,
                // twitter: state.recommendedContent[day].content.data.suggested_copy || null,
            });
        },

        toggleConnection(state, connection) {
            connection.selected = ! connection.selected;
            /* if (connection.type == 'App\\TwitterAccount' && connection.selected) {
                if (! this.state.twitterMessage && this.state.message) {
                    store.commit('setTwitterMessage', this.state.message);
                }
            } */
            store.commit('saveStickyConnections');
        },

        addShare(state, data) {
            let connection = data.connection;

            var index = state.connections.indexOf(connection);

            if (connection.shares === undefined || connection.shares === null) {
                connection.shares = [];
            }

            connection.shares.push({created_at: data.created_at});

            state.connections.splice(index, 1, connection);
        },

        resetShares(state, connection) {
            connection.shares = [];
        },

        saveStickyConnections(state) {
            if(
                state.recommendedDay !== null &&
                state.recommendedContent[state.recommendedDay].posts.data.length === 0
            ) {
                store.commit('setStickyConnections', duplicateArr(state.connections) );
            }
        },

        statusUpdate(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            payload.connection.status = payload.status;

            state.connections.splice(index, 1, payload.connection);
        },

        clearNetworks(state, payload) {
            if (payload.connection.networks  !== undefined) {
                payload.connection.networks = undefined;
            }
                
        },

        failedCodeUpdate(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            payload.connection.failed_code = payload.failed_code;

            state.connections.splice(index, 1, payload.connection);
        },

        failedSubcodeUpdate(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            payload.connection.failed_subcode = payload.failed_subcode;

            state.connections.splice(index, 1, payload.connection);
        },

        setPostId(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            payload.connection.postId = payload.postId;

            state.connections.splice(index, 1, payload.connection);
        },

        setExternalIds(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            payload.connection.externalIds = payload.externalIds;

            state.connections.splice(index, 1, payload.connection);
        },

        setPostDetails(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            payload.connection.postDetails = payload.postDetails;

            state.connections.splice(index, 1, payload.connection);
        },

        setPublishedOn(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            if(! payload.publishedOn) {
                payload.connection.publishedOn = null;
            } else {
                payload.connection.publishedOn = payload.publishedOn;
            }

            state.connections.splice(index, 1, payload.connection);
        },

        setPostUpdatedAt(state, payload) {
            var index = state.connections.indexOf(payload.connection);
            if(! payload.updatedAt) {
                payload.connection.postUpdatedAt = null;
            } else {
                payload.connection.postUpdatedAt = payload.updatedAt;
            }

            state.connections.splice(index, 1, payload.connection);
        },

        submitted(state) {
            state.submitted = true;
        },

        processing(state) {
            state.processing = true;
        },

        clear(state, day = null) {
            if(state.stickyConnections.length === 0){
                store.commit('setStickyConnections', duplicateArr(state.connections) );
            }

            if(state.recommendedDay !== null && day !== null && state.recommendedContent[day].posts.data[0] === undefined) {
                store.commit('setConnections', duplicateArr(state.stickyConnections) );
            } else {
                store.commit('resetConnections');
            }

            state.done = false;
            state.message = '';
            // state.twitterMessage = '';
            state.submitted = false;
            state.processing = false;
            state.scheduledFor = null;
            state.scheduleIsPast= false;
            state.schedule = false;
            state.attachments = [];
            state.suggested = {
                copy_tip: null,
                facebook: null,
                // twitter: null,
            };
            state.productInfo = null;
        },

        reset(state) {
            store.commit('clear');

            state.mode = null;
            //state.recommendedContent = [];
            state.recommendedDay = null;
            state.recommendedItem = null;
            state.uuid = null;
            state.hash = null;
            state.deleted = false;
            // state.separateTweet = false;
            state.inLibrary = false;
            state.repost = false;
            state.hasInvalidConnections = false;
            state.reconnected = false;
            state.productInfo = null;
        },

        prepareForRepost(state) {
            state.done = false;
            state.submitted = false;
            state.processing = false;
            state.schedule = false;
            state.scheduledFor = null;
            state.scheduleIsPast= false;
            state.createdAt = null;
            state.start = null;
            state.recommendedDay = null;
            state.recommendedItem = null;
            state.uuid = null;
            state.hash = null;
            state.deleted = false;
            state.mode = 'item';
            state.repost = true;
            state.reconnected = false;
            state.productInfo = null;

            state.attachments.forEach( (attachment) => {
                if (attachment.content !== undefined && attachment.content.data !== undefined) {
                    attachment.contentId = attachment.content.data.id;
                    attachment.contentType = attachment.content.data.media_type;
                    if(attachment.contentType !== "App\\Content\\Template") {
                        // Keep the custom image for templates
                        attachment.source = attachment.content.data.source;
                    }
                }
            });
            store.commit('resetConnections');
        },

        resetConnections(state) {
            state.connections = state.connections.map( (connection) => {
                // Clear Pinterest Selected Board
                if(connection.type == 'App\\PinterestAccount'){
                    connection.boards.selected = '';
                }

                connection.selected = false;
                connection.status = null;
                connection.postId = null;
                connection.failed_code = false;
                connection.failed_subcode = false;
                connection.shares = [];
                return connection;
            });
        },

        setHasInvalidConnections(state, value) {
            state.hasInvalidConnections = value;
        },

        toggleSchedule(state) {
            state.schedule = ! state.schedule;
        },

        setScheduledFor(state, date) {
            state.scheduledFor = date;
        },

        setScheduleIsPast(state, past) {
            state.scheduleIsPast = past;
        },

        setCreatedAt(state, date) {
            state.createdAt = date;
        },

        setStart(state, date) {
            state.start = date;
        },

        clearConnections (state) {
            state.connections = [];
        },

        addConnection (state, connection) {
            state.connections.push(connection);
        },

        deleteConnection (state, connection) {
            var index = state.connections.indexOf(connection);
            state.connections.splice(index, 1);
        },

        addAttachment (state, attachment) {
            if(state.attachments.length === 4) {
                throw "tooManyFilesException";
            }

            if(store.getters.hasGif) {
                throw 'gifException';
            }

            if(state.attachments.length > 0 && isGif(attachment)) {
                throw 'gifException';
            }

            var attachments = state.attachments;

            if (attachment.content !== undefined && attachment.content.data.urlData !== undefined && attachment.content.data.urlData !== null) {
                attachment.content.data.urlData['og\:description'] = attachment.content.data.urlData['og:description'];
                attachment.content.data.urlData['og\:image'] = attachment.content.data.urlData['og:image'];
                attachment.content.data.urlData['og\:title'] = attachment.content.data.urlData['og:title'];
                if (attachment.content.data.urlData.title === undefined) {
                    attachment.content.data.urlData.title = attachment.content.data.urlData['og:title'];
                }
            }

            if (attachment.src === undefined && attachment.source !== undefined) {
                attachment.src = attachment.source;
            }

            attachments.push(attachment);
            store.commit('setAttachments', attachments);

            return true;
        },

        removeAttachment (state, attachment) {
            var index = state.attachments.indexOf(attachment);
            state.attachments.splice(index, 1);
        },

        setAttachments (state, attachments) {
            state.attachments = attachments;
        },

        clearAttachments (state) {
            state.attachments = [];
        },

        setSuggestedCopies (state, copies) {
            state.suggested.copy_tip = copies.copy_tip;
            state.suggested.facebook = copies.facebook;
            // state.suggested.twitter = copies.twitter;
        },

        setBoard (state, payload) {
            var index = state.connections.indexOf(payload.connection);

            var connection = state.connections[index];
            connection.boards.selected = payload.board;

            Vue.set(state.connections, index, connection);
        },
        setBoards (state, boards) {
            var pinterestAccount = state.connections.filter(connection => connection.type == "App\\PinterestAccount")[0];
            var index = state.connections.indexOf(pinterestAccount);
            var connection = state.connections[index];
            connection.boards = boards;
            Vue.set(state.connections, index, connection);
        },
        setDeleted (state) {
            state.deleted = true;
        },
        initializeDropzone (state, status) {
            state.dropzoneInit = status;
        },
        setStickyConnections(state, connections) {
            state.stickyConnections = connections;
        },
        setConnections(state, stickyConnections) {
            state.connections = stickyConnections;
        },
        setInLibrary(state, status) {
            state.inLibrary = status;
        },
        setReconnected(state, status) {
            state.reconnected = status;
        },
        setTimezoneMismatch(state, timezoneMismatch) {
            state.timezoneMismatch = timezoneMismatch;
        },
        setProductInfo(state, info) {
            state.productInfo = info;
        },
    },
    actions: {
        post({ commit, state, getters }) {
            if (state.repost) {
                commit('setUuid', null);
            }

            let profileCutoffTime = moment.tz('2018-08-01 00:00', 'UTC');

            let scheduledTooLate = getters.hasFacebookProfileSelected && state.scheduledFor !== null && profileCutoffTime.isBefore(moment(state.scheduledFor));

            let postedTooLate = getters.hasFacebookProfileSelected && state.scheduledFor === null && profileCutoffTime.isBefore(moment());

            if (scheduledTooLate || postedTooLate) {
                swal({
                    title: store._vm.$i18n.general.oops,
                    text: store._vm.$i18n.post_anything.errors.profile_posting,
                    icon: "error",
                    button: store._vm.$i18n.general.close,
                });
                return;
            }

            commit('submitted');

            // If there are errors present, do Nothing...
            if(getters.errors.length > 0){
                return;
            }

            if (state.processing) {
                return;
            }

            // If we got here, start processing
            commit('processing');

            getters.selectedConnections.map((connection) => {
                commit('statusUpdate', { connection: connection, status: 'pending'});
            });

            var prePost = {
                attachments: state.attachments,
                deselectedConnections: getters.deselectedConnections
            };

            if (getters.hasFacebookProfileSelected) {
                prePost.hasFbProfile = getters.hasFacebookProfileSelected;
            }

            if (state.uuid !== null) {
                prePost.uuid = state.uuid;
            }

            // Preflight ...
            return Vue.http.post('post/preflight', prePost, { headers: { 'Accept': 'application/x.onemb.v2+json' }}).then((prepResponse) => {
                var uuid = prepResponse.data.uuid;
                var hash = prepResponse.data.hash;
                var cancelledConnections = prepResponse.data.cancelledConnections || [];
                if (uuid === undefined) {
                    swal({
                        title: store._vm.$i18n.general.oops,
                        text: store._vm.$i18n.post_anything.errors.attachment_too_big,
                        icon: "error",
                        button: store._vm.$i18n.general.close,
                    });

                    getters.selectedConnections.map((connection) => {
                        commit('statusUpdate', { connection: connection, status: 'failed'});
                    });

                    return false;
                }

                commit('setUuid', uuid);
                commit('setHash', hash);

                // Cancel posts
                cancelledConnections.map((connection) => {
                    var post = {
                        connection,
                        uuid: uuid,
                        hash: hash
                    };

                    if (connection.postId !== null) {
                        post.postId = connection.postId;
                    }

                    // Cancel Post
                    Vue.http.post(`${connection.url}/${connection.id}/post/cancel`, post, { headers: { 'Accept': 'application/x.onemb.v2+json' }}).then((response) => {
                        // Show cancelleation success (?)
                    }, (err) => {
                        // Show cancellation failure (?)
                    });
                });

                //Process OtherNetworkPages first
                if (getters.hasOtherNetworkSelected) {
                    let connection;
                    if (getters.selectedOtherNetworkPages.length == 1) {
                        connection = getters.selectedOtherNetworkPages[0];
                        connection.networks = [connection.network];
                        store.dispatch('postPost', { connection , uuid, hash });
                    } else {
                        //Consolidate all other connections into one, by filling the "networks" property
                        connection = getters.selectedOtherNetworkPages[0];
                        let networks = [];
                        getters.selectedOtherNetworkPages.map((conn) => {
                            networks.push(conn.network);
                        });
                        connection.networks = networks;
                        store.dispatch('postPost', { connection , uuid, hash });

                        //push all the remaining connections without the "networks" property
                        for (let i in getters.selectedOtherNetworkPages) {
                            if (i>0) {
                                let connection = getters.selectedOtherNetworkPages[i];
                                store.dispatch('postPost', { connection , uuid, hash });
                            }
                        }
                    }
                }

                //Process all connections that are not OtherNetwork
                getters.selectedNonOtherConnections.map((connection) => {
                    store.dispatch('postPost', { connection, uuid, hash });
                });
            });
        },
        postPost({ commit, state, getters}, { connection, uuid, hash, retry } ) {
            commit('statusUpdate', { connection: connection, status: 'pending'});

            if (uuid === undefined) {
                uuid = state.uuid;
            }
            if (hash === undefined) {
                hash = state.hash;
            }
            if (retry === undefined) {
                retry = false;
            }

            // Prepare the Post,
            // We need to send the
            // Connection and the Message
            var post = {
                connection,
                // message: connection.type === 'App\\TwitterAccount' ? state.twitterMessage.trim() : state.message.trim(), // Remove any excess whitespace and newline characters from the sides of the message string
                message: state.message.trim(), // Remove any excess whitespace and newline characters from the sides of the message string
                attachments: state.attachments,
                uuid: uuid,
                hash: hash,
                timezone_mismatch: state.timezoneMismatch,
                retry: retry
            };

            if(state.scheduledFor !== null) {
                post.scheduled_for = state.scheduledFor;
            }

            if (connection.postId !== null) {
                post.postId = connection.postId;
            }
            // Post the Post :)
            return Vue.http.post(
                `${connection.url}/${connection.id}/post`,
                post,
                {
                    headers: {
                        'Accept': 'application/x.onemb.v2+json'
                    }
                }
            ).then(
            (response) => {
                commit('statusUpdate', { connection: connection, status: 'success'});
                commit('clearNetworks', { connection: connection});
                commit('setPostId', { connection: connection, postId: response.data.data.id});

                if (state.mode == 'recommended' && state.recommendedDay !== null) {
                    var content = (response.data.data.attachments.data[0] !== undefined)?response.data.data.attachments.data[0].content:{};
                    commit('setRecommendedContentDay', { day: state.recommendedDay, content: content, post: response.data.data});
                }
            },
            (error) => {
                commit('statusUpdate', { connection: connection, status: 'failed'});
                commit('clearNetworks', { connection: connection});
            });
        },
        get({commit, state, getters}, repost) {
            var uuid = state.uuid;
            commit('reset');

            return Vue.http.get('posts/uuid/' + uuid, { params: {showFailed: true}, headers: { 'Accept': 'application/x.onemb.v2+json' }})
            .then(function (response) {
                var posts = response.data.data;

                commit('setUuid', posts[0].uuid);

                commit('setCreatedAt', posts[0].created_at);
                commit('setStart', posts[0].start);

                posts.map((post) => {
                    if (post.connection_type == 'App\\TwitterAccount') {
                        // commit('setTwitterMessage', post.message);
                        // commit('setSeparateTweet', true);
                        if (state.message == '') {
                            commit('setMessage', post.message);
                        }
                    } else {
                        commit('setMessage', post.message);
                    }

                    var connection = state.connections.find(connection => connection.id == post.connection_id && connection.type == post.connection_type);

                    //  Handle if a post connection is deleted from users connection
                    if (connection === null || connection === undefined) {
                        commit('setHasInvalidConnections', true);
                        return false;
                    }

                    if(connection.type === 'App\\PinterestAccount'){
                        connection.boards.selected = post.details.boardId;
                    }

                    commit('toggleConnection', connection);
                    commit('setPostId', { connection: connection, postId: post.id });
                    commit('setExternalIds', { connection: connection, externalIds: post.external_ids });
                    commit('setPostDetails', { connection: connection, postDetails: post.details });
                    commit('setPublishedOn', { connection: connection, publishedOn: post.published_on });
                    commit('setPostUpdatedAt', { connection: connection, updatedAt: post.updated_at });
                    if (post.status == 'failed') {
                        commit('statusUpdate', { connection: connection, status: 'failed'});
                        commit('failedCodeUpdate', { connection: connection, failed_code: post.failed_code});
                        commit('failedSubcodeUpdate', { connection: connection, failed_subcode: post.failed_subcode});

                    } else if (post.status == 'cancelled' && post.failed_code == 9999) {
                        commit('statusUpdate', { connection: connection, status: 'cancelled'});
                        commit('failedCodeUpdate', { connection: connection, failed_code: post.failed_code});
                        commit('failedSubcodeUpdate', { connection: connection, failed_subcode: post.failed_subcode});
                    } else {
                        commit('statusUpdate', { connection: connection, status: 'idle'});
                        commit('failedCodeUpdate', { connection: connection, failed_code: false});
                        commit('failedSubcodeUpdate', { connection: connection, failed_subcode: false});
                    }

                    commit('resetShares', connection);
                    if (post.connection_type == 'App\\FacebookPage' && post.shares.data.length > 0) {
                        post.shares.data.forEach(share => commit('addShare', {connection: connection, created_at: share.created_at}));
                    }
                });
                if (posts[0].scheduled_at !== null) {
                    commit('setScheduleIsPast', posts[0].schedule_is_past);
                    commit('setScheduledFor', posts[0].scheduled_at);
                }

                if (posts[0].attachments.data.length > 0) {
                    posts[0].attachments.data.map((attachment) => {
                        attachment.fromLibrary = true;
                        commit('addAttachment', attachment);
                    });
                }

                if (repost) {
                    commit('prepareForRepost');
                }
            }).catch(error => {});
        },

        delete({commit, state, getters}) {
            var uuid = state.uuid;
            return Vue.http.delete('posts/uuid/' + uuid, { headers: { 'Accept': 'application/x.onemb.v2+json' }})
            .then(function (response) {
                commit('setDeleted');
            }, (err) => {
                var errorObject = {name: 'DeletePostException', message: err.body.message};
                throw errorObject;
            });
        },

        addConnection({ commit }, connection) {
            switch(connection.type) {
                case 'App\\FacebookPage':
                    connection.icon = 'facebook';
                    connection.typeName = 'Facebook Page';
                    connection.avatarClass = 'connection-avatar';
                    connection.stackClass = 'fa fa-circle fa-stack-2x fb-icon';
                    connection.iconClass = 'fab fa-facebook-f fa-stack-1x fa-inverse';
                    connection.postId = null;
                    break;
                case 'App\\FacebookAccount':
                    connection.icon = 'facebook';
                    connection.typeName = 'Facebook Profile';
                    connection.avatarClass = 'connection-avatar';
                    connection.stackClass = 'fa fa-circle fa-stack-2x fb-icon';
                    connection.iconClass = 'fab fa-facebook-f fa-stack-1x fa-inverse';
                    connection.postId = null;
                    break;
                case 'App\\FacebookGroup':
                    connection.icon = 'facebook';
                    connection.typeName = 'Facebook Group';
                    connection.avatarClass = 'icon-avatar';
                    connection.stackClass = 'fa fa-circle fa-stack-2x fb-icon';
                    connection.iconClass = 'fab fa-facebook-f fa-stack-1x fa-inverse';
                    connection.postId = null;
                    break;
                case 'App\\InstagramPage':
                    connection.icon = 'instagram';
                    connection.typeName = 'Instagram Page';
                    connection.avatarClass = 'connection-avatar';
                    connection.stackClass = 'fa fa-circle fa-stack-2x ig-icon';
                    connection.iconClass = 'fab fa-instagram fa-stack-1x fa-inverse';
                    connection.postId = null;
                    break;
                /* case 'App\\TwitterAccount':
                    connection.icon = 'twitter';
                    connection.typeName = 'Twitter Account';
                    connection.avatarClass = 'connection-avatar';
                    connection.stackClass = 'fa fa-circle fa-stack-2x tw-icon';
                    connection.iconClass = 'fab fa-twitter fa-stack-1x fa-inverse';
                    connection.postId = null;
                    break; */
                case 'App\\PinterestAccount':
                    connection.icon = 'pinterest';
                    connection.typeName = 'Pinterest Account';
                    connection.avatarClass = 'connection-avatar';
                    connection.stackClass = 'fa fa-circle fa-stack-2x pin-icon';
                    connection.iconClass = 'fab fa-pinterest fa-stack-1x fa-inverse';
                    connection.postId = null;
                    break;
                case 'App\\OtherNetworkPage':
                    connection.icon = 'other';
                    connection.typeName = ' Mobile Companion';
                    connection.avatarClass = 'connection-avatar';
                    connection.stackClass = 'fa fa-circle fa-stack-2x oth-icon';
                    connection.iconClass = 'fas fa-mobile fa-stack-1x fa-inverse';
                    connection.postId = null;
                    if (connection.name == 'Other') {
                        connection.name = 'Other Mobile';
                    }
            }

            commit('addConnection', connection);
        },

        deleteConnection({ dispatch, commit, getters }, connection) {

            // Check if is a Facebook Account because we must delete the Pages and Groups from the state too
            if (connection.type == "App\\FacebookAccount") {
                getters.facebookPages.forEach((page) => { dispatch('deleteConnection', page); });
                getters.facebookGroups.forEach((group) => { dispatch('deleteConnection', group); });
                getters.instagramPages.forEach((instagram) => { dispatch('deleteConnection', instagram); });
            }

            commit('deleteConnection', connection);
        },

        setConnections ({ dispatch, commit }, connections) {

            commit('clearConnections');

            connections.forEach((connection) => {
                dispatch('addConnection', connection);
            });

        },

        /* toggleSeparateTweet ({ commit }) {
            commit('toggleSeparateTweet');
        }, */

        setMessage({ commit }, message) {
            commit('setMessage', message);
        },

        /* setTwitterMessage({ commit }, message) {
            commit('setTwitterMessage', message);
        }, */

        appendToMessage({ dispatch, state }, params) {
            let message = trim(state.message);
            // let twitterMessage = trim(state.twitterMessage);

            // let compareMessages = message.localeCompare(twitterMessage); // 0 means equal

            let toAppend = params.url;
            let position = params.position;

            if (position === undefined || position === null || position === false || isNaN(position)) {
                message = trim(message + ' ' + toAppend);
            } else {
                if (position > 0 && message[position] !== ' ') {
                    toAppend = ' ' + toAppend;
                }

                if (position < message.length && !['.', ',', '?', '!', ';', ':'].includes(message[position+1]) && message[position+1] !== ' ') {
                    toAppend = toAppend + ' ';
                }

                message = [message.slice(0, position), toAppend, message.slice(position)].join('');
            }

            dispatch('setMessage', message);

            /* if (compareMessages === 0) {
                twitterMessage = message;
            } else {
                // We don't really know where to put the URL
                // Rare case anyway.
                twitterMessage = trim(twitterMessage + ' ' + toAppend);
            } */

            // dispatch('setTwitterMessage', twitterMessage);
        },

        updatePostScheduleFor({dispatch, state, commit}, data) {
            commit('setUuid', data.uuid);

            return dispatch('get').then(() => {
                if (state.hasInvalidConnections) {
                    throw 'invalidConnectionException';
                }
                commit('setScheduledFor', data.scheduledFor);
                return dispatch('post');
            });
        },
        getRecommendedContent ({commit, state}) {
            return Vue.http.get('content/recommended').then(function (res) {
                var recommendedContent = res.data.data;

                if(recommendedContent !== undefined){
                  for (var i = 0; i < recommendedContent.length; i++) {
                    var content = recommendedContent[i];
                    content.post = content.post || null;
                    Vue.set(recommendedContent, i, content);
                  }
                }
                commit('setRecommendedContent', recommendedContent);
                return true;
            }).catch(error => {});
        },
        saveToContentLibrary ({commit, state, getters}, value) {
            var uuid = state.uuid;

            if (uuid === undefined || uuid === null) {
                return;
            }

            let params = {
                attachments: state.attachments,
                folder_id: value
            };

            Vue.http.post('post/' + uuid + '/save', params, { headers: { 'Accept': 'application/x.onemb.v2+json' }})
            .then(function (response) {
                commit('setInLibrary', true);
            }, (err) => {
                console.log(err);
            });
        },
        share({commit, state, getters}, data) {
            Vue.http.post('save_share/' + data.connection.postId, {}, { headers: { 'Accept': 'application/x.onemb.v2+json' }})
            .then(function (response) {
                // Add shares to connection;
                commit('addShare', {connection: data.connection, created_at: response.data.data.created_at});
            }, (err) => {
                console.log(err);
            });
        },
        refreshBoards({ commit }, data) {
            commit('setBoards', null);
            var force = false;
            if(
                typeof data !== 'undefined' &&
                typeof data.force !== 'undefined' &&
                data.force
            ) {
                force = true;
            }

            Vue.http.get('pinterest/boards' + (force ? '?force=true' : ''))
            .then(function(response) {
                commit('setBoards', response.data);
            })
            .catch(function(e) {
                if(e.status === 409) {
                    // User is on v1 still. Ignore here, handle on profile request
                    return;
                }
                if(
                    e.body.message.startsWith('Pinterest error (code: 401)') ||
                    e.body.message.startsWith('getBoards() Failure') // v3
                ) {
                    this.state.pinterest_token_invalid = true;
                } else {
                    let div = document.createElement('div');
                    div.innerHTML = e.body.message;
                    swal({
                        title: store._vm.$i18n.general.oops,
                        content: div,
                        icon: 'error',
                        button: store._vm.$i18n.general.ok
                    });
                }
                commit('setBoards', []);
            }.bind(this));
        }
    }
});

module.exports = store;



// WEBPACK FOOTER //
// ./resources/assets/js/stores/post-anything.js